import React from 'react';

export default {
	shops: [
		{
			id: 'montana',
			city: 'Монтана',
			places: [
				{
					mapState: { center: { lat: 43.40732, lng: 23.22322 }, zoom: 15 },
					city: 'Монтана',
					address: 'ул. Юлиус Ирасек 2',
					working_hours: (
						<p>
							Понеделник - Петък: 9:00-13:00ч. и 14:00-19:00ч.
							<br />
							Събота: 10:00-15:00ч.
							<br />
							Неделя: Почивен ден
						</p>
					),
					telephone: '+359 882 991 581',
					officeFeatures: ['Плащане', 'Включване', 'Преподписванe', 'Продукти'],
					easyPayOffice: ['Плащане'],
					videoStream: (
						<iframe
							width="100%"
							height="300px"
							src="https://www.youtube.com/embed/m9NnVsVzlUE"
							frameborder="0"
							allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
							allowfullscreen
						></iframe>
					)
				}
			]
		},
		{
			id: 'blagoevgrad',
			city: 'Благоевград',
			places: [
				{
					mapState: { center: { lat: 42.01466, lng: 23.08708 }, zoom: 15 },
					city: 'Благоевград',
					address: 'бул. Св.Св. Кирил и Методий 29',
					working_hours: (
						<p>
							Понеделник - Петък: 9:00-13:00ч. и 14:00-17:00ч.
							<br />
							Събота: 10:00-15:00ч.
							<br />
							Неделя: Почивен ден
						</p>
					),
					telephone: '+359 882 991 582',
					officeFeatures: ['Плащане', 'Включване', 'Преподписванe'],
					easyPayOffice: ['Плащане'],
					videoStream: (
						<iframe
							width="100%"
							height="300px"
							src="https://www.youtube.com/embed/etPV_nfzPtQ"
							frameborder="0"
							allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
							allowfullscreen
						></iframe>
					)
				}
			]
		},
		{
			id: 'lom',
			city: 'Лом',
			places: [
				{
					mapState: { center: { lat: 43.82647, lng: 23.23693 }, zoom: 15 },
					city: 'Лом',
					address: 'ул. Дунавска 10',
					working_hours: (
						<p>
							Понеделник - Петък: 9:00-13:00ч. и 14:00-17:00ч.
							<br />
							Събота - Неделя: Почивни дни
						</p>
					),
					telephone: '+359 882 991 584',
					officeFeatures: ['Плащане', 'Включване', 'Преподписванe'],
					easyPayOffice: ['Плащане']
				}
			]
		},
		{
			id: 'kozludui',
			city: 'Козлодуй',
			places: [
				{
					mapState: { center: { lat: 43.77523, lng: 23.7342 }, zoom: 15 },
					city: 'Козлодуй',
					address: 'ул. Христо Ботев (Търговски к-с "Сони")',
					working_hours: (
						<p>
							Понеделник - Петък: 9:00-13:00ч. и 14:00-17:00ч.
							<br />
							Събота и Неделя: Почивни дни
							<br />
						</p>
					),
					telephone: '+359 882 991 583',
					officeFeatures: ['Плащане', 'Включване', 'Преподписванe'],
					easyPayOffice: ['Плащане']
				}
			]
		},
		{
			id: 'berkovica',
			city: 'Берковицa',
			places: [
				{
					mapState: { center: { lat: 43.23758, lng: 23.12667 }, zoom: 15 },
					city: 'Берковицa',
					address: 'ул. Поручик Загорски 1',
					working_hours: (
						<p>
							Понеделник - Петък: 9:00-13:00ч. и 14:00-17:00ч.
							<br />
							Събота - Неделя: Почивни дни
						</p>
					),
					telephone: '+359 882 991 585',
					officeFeatures: ['Плащане', 'Включване', 'Преподписванe'],
					easyPayOffice: ['Плащане']
				}
			]
		},
		{
			id: 'vratsa',
			city: 'Враца',
			places: [
				{
					mapState: { center: { lat: 43.22246, lng: 23.5465 }, zoom: 15 },
					city: 'Врацa',
					address: 'ж.к. Дъбника, ул. Славянска, пред бл.10',
					working_hours: (
						<p>
							Временно затворен поради пандемията. Скоро ще отвори отново.
						</p>
					),
					telephone: '+359 882 991 586',
					officeFeatures: ['Плащане', 'Включване', 'Преподписванe'],
					easyPayOffice: ['Плащане']
				}
			]
		},
		{
			id: 'oryahovo',
			city: 'Оряхово',
			places: [
				{
					mapState: { center: { lat: 43.737844, lng: 23.961924 }, zoom: 15 },
					city: 'Оряхово',
					address: 'ул. Васил Левски 16 А',
					working_hours: (
						<p>
							Временно затворен поради пандемията. Скоро ще отвори отново.
						</p>
					),
					telephone: '+359 882 991 607',
					officeFeatures: ['Плащане', 'Включване', 'Преподписванe'],
					easyPayOffice: ['Плащане']
				}
			]
		}
	],

	easyPayOfficeMarkers: [
		{ marker: { lat: 43.4064, lng: 23.2257 } },
		{ marker: { lat: 43.42167, lng: 23.22707 } },
		{ marker: { lat: 43.40327, lng: 23.22837 } },
		{ marker: { lat: 43.41525, lng: 23.2182 } },
		{ marker: { lat: 43.42084, lng: 23.22823 } },
		{ marker: { lat: 43.6625, lng: 23.06768 } },
		{ marker: { lat: 43.81783, lng: 23.23833 } },
		{ marker: { lat: 43.83176, lng: 23.23333 } },
		{ marker: { lat: 43.83052, lng: 23.23768 } },
		{ marker: { lat: 43.23427, lng: 23.14157 } },
		{ marker: { lat: 43.19464, lng: 23.28741 } },
		{ marker: { lat: 43.69558, lng: 23.44497 } },
		{ marker: { lat: 43.49187, lng: 23.32408 } },
		{ marker: { lat: 43.20702, lng: 23.54493 } },
		{ marker: { lat: 43.20504, lng: 23.55598 } },
		{ marker: { lat: 43.22361, lng: 23.5522 } },
		{ marker: { lat: 43.1951, lng: 23.56628 } },
		{ marker: { lat: 43.20692, lng: 23.54724 } },
		{ marker: { lat: 43.20744, lng: 23.55244 } },
		{ marker: { lat: 43.77523, lng: 23.7342 } },
		{ marker: { lat: 43.73666, lng: 23.95991 } },
		{ marker: { lat: 43.73618, lng: 23.95579 } },
		{ marker: { lat: 41.99496, lng: 23.08902 } },
		{ marker: { lat: 42.01758, lng: 23.09702 } },
		{ marker: { lat: 42.01979, lng: 23.09305 } },
		{ marker: { lat: 42.00645, lng: 23.09514 } }
	],

	shopsMarkers: [
		{ lat: 43.40732, lng: 23.22322 },
		{ lat: 42.01466, lng: 23.08708 },
		{ lat: 43.82647, lng: 23.23693 },
		{ lat: 43.7751525, lng: 23.7330693 },
		{ lat: 43.23758, lng: 23.12667 },
		{ lat: 43.22246, lng: 23.5465 },
		{ lat: 43.737844, lng: 23.961924 },
		{ lat: 43.19306797579407, lng: 23.283452053431986 }
	],

	coverageMarkers: [
		{ lat: 43.40851, lng: 23.22572 },
		{ lat: 43.38588, lng: 23.03053 },
		{ lat: 43.3534, lng: 23.22187 },
		{ lat: 43.32379, lng: 23.18068 },
		{ lat: 43.44117, lng: 23.28355 },
		{ lat: 43.48231, lng: 23.28861 },
		{ lat: 43.4202, lng: 23.27625 },
		{ lat: 43.66274, lng: 23.06657 },
		{ lat: 43.29624, lng: 23.24238 },
		{ lat: 43.28509, lng: 23.07114 },
		{ lat: 43.62811, lng: 23.1748 },
		{ lat: 43.81783, lng: 23.23833 },
		{ lat: 43.23704, lng: 23.1251 },
		{ lat: 43.19387, lng: 23.28658 },
		{ lat: 43.69497, lng: 23.4427 },
		{ lat: 43.4715, lng: 23.33269 },
		{ lat: 43.21023, lng: 23.55288 },
		{ lat: 43.77556, lng: 23.72461 },
		{ lat: 43.73223, lng: 23.96073 },
		{ lat: 43.67283, lng: 23.99108 },
		{ lat: 43.6787, lng: 24.13929 },
		{ lat: 43.70774, lng: 24.01453 },
		{ lat: 43.64774, lng: 23.84261 },
		{ lat: 43.62601, lng: 23.83985 },
		{ lat: 42.02085, lng: 23.09433 },
		{ lat: 41.95883, lng: 23.12789 },
		{ lat: 42.08458, lng: 23.05578 },
		{ lat: 42.04012, lng: 23.06557 },
		{ lat: 42.04618, lng: 23.02286 },
		{ lat: 42.0629, lng: 23.06004 },
		{ lat: 41.97592, lng: 23.05291 },
		{ lat: 42.04838, lng: 23.1318 },
		{ lat: 42.0093, lng: 23.03187 },
		{ lat: 41.99023, lng: 23.1111 },
		{ lat: 42.09551, lng: 23.10517 },
		{ lat: 42.07646, lng: 23.08518 },
		{ lat: 42.03191, lng: 23.04731 },
		{ lat: 41.99639, lng: 22.99883 },
		{ lat: 42.02414, lng: 23.03252 },
		{ lat: 42.00098, lng: 23.1274 },
		{ lat: 43.21536, lng: 23.18687 },
		{ lat: 43.20067, lng: 23.16167 },
		{ lat: 43.43304, lng: 23.12582 }
	]
};

